import React from 'react';
import {
    Modal,
    Box,
    Typography,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CommonButton from '../Button/Button';
import { addButtonStyle, cancelButtonStyle } from '../Button/ButtonStyles';

const CommonModal = ({
    open,
    handleClose,
    title,
    message,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
     onCancel, 
}) => {
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: 500,
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '16px',
        p: 3,
        textAlign: 'center',
    };

    

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={modalStyle}>
                <IconButton
                    onClick={handleClose}
                    sx={{ position: 'absolute', top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>

                <Box
                    sx={{
                        width: 48,
                        height: 48,
                        backgroundColor: 'rgba(51, 102, 255, 0.1)',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '15px auto',
                    }}
                >
                    <InfoOutlinedIcon sx={{ color: '#3366FF' }} />
                </Box>

                <Typography variant="h6" fontWeight={600} gutterBottom>
                    {title}
                </Typography>

                <Typography sx={{ mb: 3, color: '#7A7A7A' }} fontWeight={400}>
                    {message}
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                  <CommonButton
  fullWidth
  text={confirmText}
  onClick={() => {
  console.log("✅ Confirm button clicked");
  if (typeof onConfirm === 'function') {
    onConfirm();
  }
  handleClose();
}}

  sx={addButtonStyle}
/>

                    <CommonButton
                        fullWidth
                        text={cancelText}
                         onClick={onCancel || handleClose}
                        sx={cancelButtonStyle}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default CommonModal;
